module.exports = __webpack_public_path__ + "img/caogao.53f68abe.png";